module.exports = __webpack_public_path__ + "static/type-brigade-50-banner-571b206f59717d6d25dcf32b660d5e55.png";